const BSC_RPC_ENDPOINTS = [
  "https://bsc-dataseed.binance.org",
  "https://bsc-dataseed1.defibit.io",
  "https://bsc-dataseed1.ninicoin.io",
  "https://bsc-dataseed2.defibit.io",
  "https://bsc-dataseed3.defibit.io",
  "https://bsc-dataseed4.defibit.io",
  "https://bsc-dataseed2.ninicoin.io",
  "https://bsc-dataseed3.ninicoin.io",
  "https://bsc-dataseed4.ninicoin.io",
  "https://bsc-dataseed1.binance.org",
  "https://bsc-dataseed2.binance.org",
  "https://bsc-dataseed3.binance.org",
  "https://bsc-dataseed4.binance.org",
];

const BSC_TESTNET_ENDPOINTS = "https://data-seed-prebsc-1-s1.binance.org:8545/";

const FANTOM_RPC = "https://rpc.ftm.tools";

const KOVAN_RPC = "https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161";

const AVALANCHE_RPC = "https://api.avax.network/ext/bc/C/rpc";

const BSC_CHAIN_ID = 56;
const FANTOM_CHAIN_ID = 250;
const KOVAN_CHAIN_ID = 42;
const AVALANCHE_CHAIN_ID = 43114;
const BSC_TESTNET_CHAIN_ID = 97;

export {
  BSC_RPC_ENDPOINTS,
  FANTOM_RPC,
  BSC_CHAIN_ID,
  FANTOM_CHAIN_ID,
  KOVAN_CHAIN_ID,
  KOVAN_RPC,
  AVALANCHE_RPC,
  AVALANCHE_CHAIN_ID,
  BSC_TESTNET_CHAIN_ID,
  BSC_TESTNET_ENDPOINTS,
};
